import React from "react";
import './OptionTitle.module.css'
import 'colors.css'
import 'styles/css/general.css'

interface Props {
    title: string;
    expanded?: boolean;
    controls?: string;
    onClick?: ((params: any) => any) | undefined;
}

function OptionTitle({ title = '', onClick, expanded, controls }: Props) {
    return (
        <div className="optionTitle">
            <h4>{onClick ? <button type="button" onClick={onClick} aria-expanded={expanded} aria-controls={controls}>
                {title}<span aria-hidden="true">{expanded ? '−' : '+'}</span>
            </button> : title}</h4>
        </div>
    );
}

export default OptionTitle;